export default "__VITE_ASSET__B$bL8L9A__"